export class InvestigationMessageEntity {
  public id!: string;
  public messageType!: number;
  public body!: string;
  public senderUserId!: string | null;
  public senderName!: string | null;
  public senderFirstName!: string | null;
  public senderLastName!: string | null;
  public isRequestor!: boolean;
  public createdOn!: string;
}
